
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired9c9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired9c9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $6bb7edd1ea388405$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["5ReQc","index.db207804.js","4aXzf","NewFullTile.637870fa.png","9fimd","SelectionCursor.e390debd.png","5XSHn","MoveCursor.b0dcdf2f.png","6PlPY","DamageCursor.e6c46f29.png","9KVNd","explosion.fcafad1f.wav","4cOOP","Smoke.7bc6cfe7.png","eRPwm","hit.cc332530.wav","gZjTq","move.8e8aee5f.wav","dH5bF","unitselect.d85b2a99.wav","6CySo","targetselect.05425c18.wav","hCeJO","Battle_of_Hastings.0318f4fb.mp3","kv6V0","Path_of_the_Warrior.4fea06b6.mp3","65BDt","ArcherA.9d192ed0.png","1pIjW","ArcherB.e35d1ce2.png","dYWUi","BarbarianA.766fd862.png","gffZA","BarbarianB.d3e3e083.png","ltKqp","ClericA.008e5f73.png","Am7rq","ClericB.bf0f03e3.png","hR7po","FighterA.f1fc51e9.png","8Tsj7","FighterB.6b021f79.png","8snQT","MageA.8b6c3f6a.png","83Hub","MageB.d57c0341.png","gX2sT","SpearmanA.b05b69f0.png","djsRW","SpearmanB.2327a40c.png","a4Z6l","WarriorA.c17e7ca7.png","ff7Dq","WarriorB.f1f2e88a.png","aVsRc","ThiefA.402f8553.png","2BvjX","ThiefB.ec90fd6d.png","3GKnR","Map1.e5ddca8b.png","722Kp","Map2.f9a200ac.png","5yUT1","map_1.b1212bd4.tmx","dw0US","map_2.f13c091c.tmx","d1MEC","NewFullTile.d51ecf23.tsx","83xHf","NotJamSlab14.5de0988d.ttf"]'));


//# sourceMappingURL=index.runtime.95d1edbd.js.map
